import NumberInput from './NumberInput'
import fillNumberInput from './testHelper/fillNumberInput'
import expectNumberInputValue from './testHelper/expectNumberInputValue'

export default NumberInput

export { fillNumberInput, expectNumberInputValue }
